export default "__VITE_ASSET__NT8YaQRq__"